(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initInfinite(root) {
    if (!root || root.dataset.lmpInfiniteBound === 'true') return;
    root.dataset.lmpInfiniteBound = 'true';

    var grid = root.querySelector('[data-lmp-products-grid]');
    var button = root.querySelector('[data-lmp-load-more]');
    var panel = root.querySelector('[data-lmp-infinite-panel]');
    var sentinel = root.querySelector('[data-lmp-infinite-sentinel]');
    if (!grid || !button) return;

    var loading = false;
    var finished = false;

    function setLoading(isLoading) {
      loading = isLoading;
      button.disabled = isLoading;
      button.textContent = isLoading ? 'Produkte werden geladen ...' : 'Weitere Produkte laden';
      if (panel) panel.classList.toggle('is-loading', isLoading);
    }

    function loadNext() {
      var nextUrl = button.getAttribute('data-next-url');
      if (!nextUrl || loading || finished) return;
      setLoading(true);

      fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = doc.querySelector('[data-lmp-products-grid]');
          var nextCards = nextGrid ? Array.prototype.slice.call(nextGrid.querySelectorAll('[data-lmp-product-card]')) : [];
          if (nextCards.length) {
            nextCards.forEach(function (card) { grid.appendChild(document.importNode(card, true)); });
            document.dispatchEvent(new CustomEvent('lmp:products:appended'));
          }

          var nextButton = doc.querySelector('[data-lmp-load-more]');
          var nextNextUrl = nextButton ? nextButton.getAttribute('data-next-url') : '';
          if (nextNextUrl) {
            button.setAttribute('data-next-url', nextNextUrl);
            setLoading(false);
          } else {
            finished = true;
            if (panel) {
              panel.innerHTML = '<p class="lmp-infinite-text lmp-infinite-text--done">Alle sichtbaren Produkte dieser Auswahl wurden geladen.</p>';
            }
          }
        })
        .catch(function () {
          setLoading(false);
          button.textContent = 'Laden erneut versuchen';
        });
    }

    button.addEventListener('click', loadNext);

    if ('IntersectionObserver' in window && sentinel) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNext();
        });
      }, { rootMargin: '520px 0px 520px 0px' });
      observer.observe(sentinel);
    }
  }

  ready(function () {
    document.querySelectorAll('[data-lmp-infinite-root]').forEach(initInfinite);
  });
})();
